/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/style-encapsulation';

import { UpgradeNudgeLayout } from '@zapier/upsells/src/components/UpgradeNudgeLayout';
import { upgradeReasons } from '@zapier/upsells/src/types';

import { CancelButton } from '../CancelButton';
import { ExtendTrialButton } from '../ExtendTrialButton';
import { NudgeImage } from '../NudgeImage';
import { UpgradeButton } from '../UpgradeButton';

import { getActiveView } from './getActiveView';

export type Props = {
  canExtendTrial: boolean;
  onClose: () => void;
  onExtendTrialClick: () => void;
  onUpgradeClick: () => void;
};

export const MultistepUpgradeNudge = ({
  canExtendTrial,
  onClose,
  onExtendTrialClick,
  onUpgradeClick,
}: Props) => {
  const activeView = getActiveView({
    canExtendTrial,
    onUpgradeClick,
  });

  const secondaryButton = canExtendTrial ? (
    <ExtendTrialButton
      key="extend-trial"
      onClick={onExtendTrialClick}
      text="Try Professional"
    />
  ) : (
    <CancelButton key="cancel" onClick={onClose} />
  );

  return (
    <UpgradeNudgeLayout
      bodyText={activeView.bodyText}
      buttons={[
        secondaryButton,
        <UpgradeButton
          key="upgrade"
          onClick={onUpgradeClick}
          text={activeView.upgradeButtonText}
        />,
      ]}
      headingText="Unlock multi-step Zaps to continue"
      id="multistep"
      image={<NudgeImage type={upgradeReasons.multistep} />}
      subtitleText="Paid Feature"
    />
  );
};
